<template>
    <div id="car-intro">
        <div id="text-block">
            <body id="car-name-header">
                PRESENTING OUR 2026 CAR
            </body>
            <h1 id="car-name">
                ORIGIN
            </h1>
        </div>
        <img
            id="car-image"
            src="@/assets/race26/DSC_1972.JPG"
        />
    </div>
</template>

<script>
export default {
    name: "CarIntroduction",
};
</script>

<style lang="scss" scoped>
#car-name-header {
    font-size: 1em;
    margin-bottom: 0.5em;
}

#car-name {
    font-size: 4em;
    margin-top: 0em;
}

#car-intro {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2.5rem;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
}

#car-image {
    display: inline-block;
    max-width: 450px;
    width: 90%;
    margin-left: 1.5rem;
    border-radius: 95px;
}

@media screen and (max-width: 960px) {
    #car-image {
        margin-left: 0;
    }
}
</style>
